import React from "react";

function ModalFailureLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M32 64C14.3264 64 0 49.6736 0 32C0 14.3264 14.3264 0 32 0C49.6736 0 64 14.3264 64 32C64 49.6736 49.6736 64 32 64ZM32 57.6C38.7895 57.6 45.301 54.9029 50.1019 50.1019C54.9029 45.301 57.6 38.7895 57.6 32C57.6 25.2105 54.9029 18.699 50.1019 13.8981C45.301 9.09714 38.7895 6.4 32 6.4C25.2105 6.4 18.699 9.09714 13.8981 13.8981C9.09714 18.699 6.4 25.2105 6.4 32C6.4 38.7895 9.09714 45.301 13.8981 50.1019C18.699 54.9029 25.2105 57.6 32 57.6ZM32 27.4752L41.0496 18.4224L45.5776 22.9504L36.5248 32L45.5776 41.0496L41.0496 45.5776L32 36.5248L22.9504 45.5776L18.4224 41.0496L27.4752 32L18.4224 22.9504L22.9504 18.4224L32 27.4752Z"
        fill="#F15A61"
      />
    </svg>
  );
}

export default ModalFailureLogo;
